import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import InBoundForm from "../../pages/appointment-details/InBoundForm";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import ProgressTracker from "../../bmr/components/common/ProgressTracker";
import LmsKitLabel from "../../bmr/components/features/LmsKitLabel";
import { Box } from "@mui/material";
import moment from "moment";
import { getPatientDetailsById } from "../../bmr/slices/QRCode";
import { fetchSubjectPreset, fetchV2V, markedAsReceived, selectActiveV2VCycle, selectAllInitialSteps, selectCurrentCycle, startApheresis } from "../../bmr/slices/common";
import MarkedAsDispatched from "./MarkedAsDispatched";
import OutBondForm from "../../bmr/pages/LogisticsManagement/OutBound/Form";
import { completeInfusion, recieveProductLSM } from "../../bmr/slices/logisticSlice";
import BreadCrumb from "../../pages/breadcrumb/BreadCrumb"
import ChatModule from "../../bmr/pages/Chat/index";
import { addPatientList, addPhaseList } from "../../bmr/slices/chat";
import { notify } from "../../bmr/utils/methods/notification";
import {capitalizeWords} from "../../utils/utils"

const InboundFormContainer = () => {
  const dispatch = useDispatch();
  const currentCycle = useSelector(selectCurrentCycle);
  const { subjectId, inboundId } = useParams();
  const [subjectDetails, setSubjectDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [patientData, setPatientData] = useState(false);
  const [patientInfo, setPatientInfo] = useState({});
  const [patientMedicalInfo, setPatientMedicalInfo] = useState({});
  const allInitialSteps = useSelector(selectAllInitialSteps)
  const activeV2VCycle = useSelector(selectActiveV2VCycle) || 0
  const [isApheresis, setIsApheresis] = useState(false)
  const [IsInfusion, setIsInfusion] = useState(false)
  const { phaseId } = useParams();
  const [printPatientInfo, setPrintPatientInfo] = useState({});
  const [ids, setIds] = useState('')

  const phaseType = printPatientInfo?.phase_type?.toLowerCase();
  const phaseLabels = {
    patient: phaseType === "commercial" ? "Patient " : "Subject ",
    hospital: phaseType === "commercial" ? "Hospital " : "Site ",
  };
  const BreadCumArray = [
        {
            "name": "Phases",
            "path": "phases"
        },
        {
            "name": "Phase Details",
            "path": `phases/phase-details/${phaseId}`
        },
        {
            "name": "Inbound Form",
            "path": location.pathname
        }
       ];
       
  const getSubjectDetails = async () => {
    try {
      const res = await dispatch(fetchSubjectPreset(subjectId));
      setSubjectDetails(res?.payload);
    } catch (error) {
      notify.error(error)
    } finally {
      setLoading(false);
    }
  };


  const getTimeLineEditor = async () => {
    try {
      const res = await dispatch(fetchV2V({ portal_type: 1, patient_id: subjectId })).unwrap();
      if (res?.status == 200) {
        const IsAphersisExists = res?.data[activeV2VCycle]?.data?.some(
          (item) => item.slug === 'apheresis' && item.status === 0
        );
        const IsInfusionExists = res?.data[activeV2VCycle]?.data?.some(
          (item) => item.slug === 'product-shipped' && item.status === 2
        );
        setIsApheresis(IsAphersisExists);
        setIsInfusion(IsInfusionExists);
      }
      await fetchPatientInfo();
    } catch (error) {
      console.error("Failed to fetch timeline editor:", error);
    } finally {
      setLoading(false);
    }
  }

  const fetchPatientInfo = async (id = currentCycle?.qr_code_generation_id || patientData?.inbond_form_id || inboundId) => {
    try {
      const patientDetailsResponse = await dispatch(
        getPatientDetailsById({id:id,prodmfg:currentCycle?.product_manufacturing_id})
      ).unwrap();
      const patientDetails = patientDetailsResponse?.data?.patient_information;
      const isBagCount = patientDetailsResponse?.data?.number_of_bags;
      const isCommercial = patientDetailsResponse?.data?.phase_type?.toLowerCase() === "commercial";
      const phaseLabels = {
        patient: isCommercial ? "Patient " : "Subject ",
        hospital: isCommercial ? "Hospital " : "Site ",
      };
      if (patientDetails) {
        const patientBasicInfo = {
          patientName: patientDetails?.name || "-",
          phase_type: patientDetailsResponse?.data?.phase_type,
          patientInitials: patientDetails?.patient_initials,
          id: patientDetails?.id,
          product_id:patientDetailsResponse?.data?.product_id,
          phase_id:patientDetails?.phase_id,
          patientId: patientDetails?.immunoact_patient_id || "-",
          hospital_patient_id: patientDetailsResponse?.data?.hospital_patient_id || "",
          immunoactPatientId: patientDetails?.immunoact_patient_id || "-",
          logisticOperationId: patientDetailsResponse?.data?.logistics_operation_id ?? null,
          product_logistic_id:currentCycle.shipment_logistic_id ? currentCycle.shipment_logistic_id : patientDetailsResponse?.data?.product_logistic_id
        };
        const patientMedicalRecord = {
          [`${phaseLabels.patient}Body Weight`]: `${patientDetails?.body_weight} kg` || "-",
          "Disease Indication": capitalizeWords(patientDetails?.disease) || "-",
          "Date of Birth": patientDetails?.dob
            ? moment(patientDetails.dob).format("DD/MM/YYYY")
            : "-",
           [`${phaseLabels.hospital}`]: patientDetails?.hospital || "-",
            [`${phaseLabels.hospital}${phaseLabels.patient} ID`]: patientDetailsResponse?.data?.hospital_patient_id || "-",
          "Ship & Store": "2-8 degree celsius",
          "Total no Bags": isBagCount ?? 0,
          "Batch ID": patientDetailsResponse?.data?.batch_no || "-",
        };
        setPatientData(patientDetailsResponse?.data)
        setPatientInfo(patientBasicInfo);
        setPatientMedicalInfo(patientMedicalRecord);
        setPrintPatientInfo(patientDetailsResponse?.data)
      }
    }
    catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    if (currentCycle) {
      setPatientMedicalInfo((prev) => ({
        ...prev,
        "Total no Bags": currentCycle?.no_of_bags || 0,
        "Batch ID": currentCycle?.batch_no
      }));
    }
  }, [currentCycle]);

  useEffect(() => {
    if (patientData) {
      const phaseList = [{ value: patientData?.patient_information?.phase_id, label: `${patientData?.phase_name} (${patientData?.product_name})`, patient_id: patientData?.patient_information?.id }]
      const patientList = [{ value: patientData?.patient_information?.id, label: `${patientData?.patient_information?.name}`, phase_id: patientData?.patient_information?.phase_id }]
      dispatch(addPatientList(patientList))
      dispatch(addPhaseList(phaseList))
    }
  }, [patientData])


  useEffect(() => {
    setLoading(true);
    getTimeLineEditor()
  }, [activeV2VCycle]);

  useEffect(() => {
    setLoading(true);
    getSubjectDetails();
    getTimeLineEditor()
  }, []);

  useEffect(() => {
    if(ids){
  fetchPatientInfo(ids);
  setIds('')
    }
  }, [ids]);
  
  useEffect(() => {
      setIds(patientData?.inbond_form_id || inboundId)
  },[inboundId])

  useEffect(() => {
    if(!ids)
      fetchPatientInfo()
  },[currentCycle?.product_manufacturing_id])

  
  const handleAction = async (step) => {
    if (step.slug == 'lsm-received-cdm') {
      await dispatch(markedAsReceived({ patient_id: subjectId, feasibility_id: currentCycle?.feasibility_assessments_id }))
    }
    if (step.slug == 'apheresis') {
      await dispatch(startApheresis({ patient_id: subjectId, feasibility_id: currentCycle?.feasibility_assessments_id }))
    }
    if (step.slug == 'product-received') {
      await dispatch(recieveProductLSM(patientInfo?.product_logistic_id))
    }
    if (step.slug == 'infusion' && step.status == 4) {
      await dispatch(completeInfusion(patientInfo?.product_logistic_id))
    }
    getTimeLineEditor();
  }

  useEffect(() => {
    if (currentCycle?.shipment_logistic_id) {
      setPatientInfo(prev => ({
        ...prev,
        product_logistic_id: currentCycle.shipment_logistic_id,
      }));
    }
  }, [currentCycle]);

  return (

    <Box>
      <Box container className="mt-4 ml-3 mr-3 mainDiv">
        <BreadCrumb BreadCrumbsListing={BreadCumArray} />
        <LmsKitLabel
          screenType='logistics'
          qrCodeId={currentCycle?.qr_code_generation_id}
          patientInfo={patientInfo}
          patientMedicalInfo={patientMedicalInfo}
          phaseLabels={phaseLabels}
        />
      </Box>
      <Box container className="mt-4 ml-3 mr-3 pb-3 mainDiv">
        <ProgressTracker
          steps={allInitialSteps}
          onUpdate={getTimeLineEditor}
          onAction={handleAction}
          FormComponent={MarkedAsDispatched}
          patient_id={subjectId}
          buttonPop={['add_infusion_date']}
          formProps={{ product_logistic_id: patientInfo?.product_logistic_id }}
          id={currentCycle?.feasibility_assessments_id} />
      </Box>
      <Box className="mt-4 ml-3 mr-3 pb-3">
        {loading ? (
          <SkeletonLoader rowCount={1} height={80} isTable={false} />
        ) :
          (IsInfusion &&
            <div className="mt-2 mb-2">
              <OutBondForm
                updateTimeLine={getTimeLineEditor}
                subjectId={patientData?.patient_information?.id}
                printPatientInfo={printPatientInfo}
                phaseLabels={phaseLabels}
            />
            </div>)
        }
        {loading ? (
          <SkeletonLoader rowCount={1} height={80} isTable={false} />
        ) :
          <>
            {!isApheresis &&
              <InBoundForm
                patientData={{
                  ...subjectDetails,
                  ...patientData,
                  inbond_form_id: currentCycle?.inbond_patients_id,
                  patient_id: patientData?.patient_information?.id
                }}
                updateTimeLine={getTimeLineEditor}
                initialSteps={allInitialSteps}
                printPatientInfo={printPatientInfo}
              phaseLabels={phaseLabels}
              />
            }
            <ChatModule />
            
          </>
        }
      </Box>
    </Box>
  );
};

export default InboundFormContainer;
